import script from "./StipulationText.vue?vue&type=script&setup=true&lang=ts"
export * from "./StipulationText.vue?vue&type=script&setup=true&lang=ts"

import "./StipulationText.vue?vue&type=style&index=0&id=2ffdcdaf&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffdcdaf"]])

export default __exports__